// @flow
const formState = {
  input: '',
  error: false,
};

export default formState;
